"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { HomeFeaturedSitesMap } from "@/components";
import { useAtomValue } from "jotai";
import { featuredTagAtom, featuredSitesAtom } from "@/store/home";
import { Button, cn } from "@oreme/ui";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { cva } from "class-variance-authority";
import { RMapContextProvider } from "maplibre-react-components";

const sectionFeaturedSitesVariants = cva(
  "relative flex flex-col flex-1 p-4 md:p-8 min-h-[640px] border rounded-xl bg-background overflow-hidden",
);

function HomeFeaturedSites(): ReactElement | null {
  const t = useTranslations("home.FeaturedSites");
  const featuredSites = useAtomValue(featuredSitesAtom);
  const featuredTag = useAtomValue(featuredTagAtom);

  return (
    <div className={cn(sectionFeaturedSitesVariants())}>
      <header className="relative z-10 text-center max-w-sm mx-auto">
        <h3 className="text-2xl font-semibold text-black">{t("title")}</h3>
      </header>
      <div className="absolute inset-0 w-full h-full">
        <RMapContextProvider>
          <HomeFeaturedSitesMap sites={featuredSites} />
        </RMapContextProvider>
      </div>
      <footer className="relative z-10 mt-auto text-center">
        <Button className="border-0 flex sm:inline-flex" asChild>
          <Link href={`/sites/?tag=${featuredTag!.id}`}>
            {t("action")} <ArrowRight strokeWidth={1} />
          </Link>
        </Button>
      </footer>
    </div>
  );
}

export { HomeFeaturedSites };
